import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, Chip, Button } from "@mui/material";

const ViewDetailsModal = ({ open, onClose, data, fields, title, theme }) => {

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary }}>
        {title || "Details"}
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: theme.palette.background.default, color: theme.palette.text.primary }}>
        {data ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {fields.map((field) => (
              <Typography key={field.key} variant="body1">
                <strong>{field.label}:</strong>{" "}
                {Array.isArray(data[field.key]) ? (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                    {data[field.key]?.map((item, index) => (
                      <Chip
                        key={index}
                        label={item}
                        sx={{
                          backgroundColor: theme.palette.primary.main,
                          color: theme.palette.text.primary,
                          fontWeight: "bold",
                        }}
                      />
                    ))}
                  </Box>
                ) : (
                  data[field.key] || "N/A"
                )}
              </Typography>
            ))}
          </Box>
        ) : (
          <Typography variant="body1">No data available</Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ backgroundColor: theme.palette.background.paper }}>
        <Button onClick={onClose} sx={{ color: theme.palette.primary.main }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewDetailsModal;